import React from 'react';
import { useSpring } from 'react-spring';
import PropTypes from 'prop-types';
import { WarningOctagonIcon } from "@phosphor-icons/react/dist/csr/WarningOctagon";
import { flattenErrors } from '@src/utils/helpers/errorMessagesHelper';
import { WellContainer, TitleRow, IconWrapper, Title, ErrorList, ErrorItem } from './errorWell.styles';

const ErrorWell = ({ errors, touched }) => {
    const errorMessages = flattenErrors(errors, touched);
    const hasErrors = errorMessages.length > 0;
    const animation = useSpring({
        from: { maxHeight: 0, opacity: 0 },
        to: hasErrors
            ? { maxHeight: 500, opacity: 1 }
            : { maxHeight: 0, opacity: 0 },
        config: { duration: 650 },
    });

    if (!hasErrors) return null;

    return (
        <WellContainer style={animation} data-testid="error-well">
            <TitleRow>
                <IconWrapper>
                    <WarningOctagonIcon size={28} color="#BF0E0E" weight="regular" />
                </IconWrapper>
                <Title>There are errors that require your attention:</Title>
            </TitleRow>
            <ErrorList>
                {errorMessages.map((err, idx) => (
                    <ErrorItem key={`error-item-${idx + 1}`}>{err}</ErrorItem>
                ))}
            </ErrorList>
        </WellContainer>
    );
};

ErrorWell.propTypes = {
    errors: PropTypes.object.isRequired,
};

export default ErrorWell;